import { createContext, ReactNode, useContext } from "react";
import { useSections } from "../hooks/users/useSections";
import { SectionModel } from "../hooks/users/models/SectionModel";

interface UserSectionCtxType {
    sections: SectionModel[];
    loading: boolean;
    loadSections: () => Promise<void>;
}

const UserSectionCtx = createContext<UserSectionCtxType | undefined>(undefined);

export const UserSectionCtxProvider: React.FC<{children: ReactNode}> = ({children}) => {
    const { sections, loading, loadSections } = useSections();
    const value: UserSectionCtxType = {
        sections,
        loading,
        loadSections,
    }

    return <UserSectionCtx.Provider value={value}>{children}</UserSectionCtx.Provider>
}

export const useUserSections = () => {
    const ctx = useContext(UserSectionCtx);
    if(!ctx)
        throw new Error('useUserSections must be inside of UserSectionCtxProvider')
    return ctx;
}